import React, { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import './App.css';

function Unauthorized() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    comment: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Netlify Forms handles the submission automatically
    const form = e.target;
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(() => {
        setSubmitted(true);
        setFormData({ name: '', email: '', comment: '' });
      })
      .catch((error) => {
        console.error('Form submission error:', error);
        alert('There was an error submitting your request. Please try again.');
      });
  };

  const handleBackToHome = () => {
    // Sign out the user before going back to home
    signOut(auth).then(() => {
      window.location.href = '/';
    });
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Access Request Required</h1>
        <p>We apologize, but Orchestral AI is currently in a closed beta phase.</p>
        <p>We're working hard to expand access to more users soon!</p>
      </header>

      <div className="container" style={{ maxWidth: '500px', margin: '2rem auto', padding: '0 1rem' }}>
        {!submitted ? (
          <>
            <h2>Request Access</h2>
            <p>Please fill out the form below and we'll get back to you as soon as we can expand our beta program.</p>

            <form
              name="access-request"
              method="POST"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                textAlign: 'left'
              }}
            >
              {/* Hidden field for Netlify Forms */}
              <input type="hidden" name="form-name" value="access-request" />

              {/* Honeypot field for spam prevention */}
              <p style={{ display: 'none' }}>
                <label>
                  Don't fill this out if you're human: <input name="bot-field" />
                </label>
              </p>

              <div>
                <label htmlFor="name" style={{ display: 'block', marginBottom: '0.5rem' }}>
                  Name <span style={{ color: '#ff6b6b' }}>*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    fontSize: '1rem',
                    borderRadius: '5px',
                    border: '1px solid #ccc'
                  }}
                />
              </div>

              <div>
                <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem' }}>
                  Email <span style={{ color: '#ff6b6b' }}>*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    fontSize: '1rem',
                    borderRadius: '5px',
                    border: '1px solid #ccc'
                  }}
                />
              </div>

              <div>
                <label htmlFor="comment" style={{ display: 'block', marginBottom: '0.5rem' }}>
                  Additional Comments (Optional)
                </label>
                <textarea
                  id="comment"
                  name="comment"
                  value={formData.comment}
                  onChange={handleChange}
                  rows="4"
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    fontSize: '1rem',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    resize: 'vertical'
                  }}
                />
              </div>

              <button
                type="submit"
                className="btn"
                style={{ alignSelf: 'center', marginTop: '1rem' }}
              >
                Submit Request
              </button>
            </form>

            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <p style={{ color: '#666' }}>or</p>
              <button
                className="btn"
                onClick={handleBackToHome}
                style={{ backgroundColor: '#666', marginTop: '0.5rem' }}
              >
                Back to Home
              </button>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h2 style={{ color: '#4caf50' }}>Thank You!</h2>
            <p>Your access request has been submitted successfully.</p>
            <p>We'll review your request and get back to you soon.</p>
            <button
              className="btn"
              onClick={handleBackToHome}
              style={{ marginTop: '1.5rem' }}
            >
              Back to Home
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Unauthorized;
